/**
 * @generated SignedSource<<5c80bbda005b539e3693ad4c5e00280d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type agentRunStateScheduleQuery$variables = {
  consumer: string;
};
export type agentRunStateScheduleQuery$data = {
  readonly viewer: {
    readonly scheduleSet: {
      readonly id: string;
      readonly enabled: boolean;
      readonly schedules: ReadonlyArray<{
        readonly id: string;
      }>;
    } | null;
  } | null;
};
export type agentRunStateScheduleQuery = {
  variables: agentRunStateScheduleQuery$variables;
  response: agentRunStateScheduleQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "consumer"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "consumer",
      "variableName": "consumer"
    }
  ],
  "concreteType": "ScheduleSet",
  "kind": "LinkedField",
  "name": "scheduleSet",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "enabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Schedule",
      "kind": "LinkedField",
      "name": "schedules",
      "plural": true,
      "selections": [
        (v1/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "agentRunStateScheduleQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "agentRunStateScheduleQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "826a467bf37188c841608b4595901660",
    "id": null,
    "metadata": {},
    "name": "agentRunStateScheduleQuery",
    "operationKind": "query",
    "text": "query agentRunStateScheduleQuery(\n  $consumer: String!\n) {\n  viewer {\n    scheduleSet(consumer: $consumer) {\n      id\n      enabled\n      schedules {\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "6f04ac02c23e8b5dc7811b445e0d02a7";

export default node;
